<template>
  <full-size-page-layout>
    <form-card-alive-check
      ref="aliveCheck"
      class="max-w-2xl mx-auto"
      @alive="handleTryAgain"
    />
  </full-size-page-layout>
</template>

<script>
  import { LayoutOutsideOrganization } from '@/layouts'
  import FormCardAliveCheck from '@/components/form/form-card-alive-check.vue'

  export default {
    name: 'NetworkError',
    components: { FormCardAliveCheck, FullSizePageLayout: LayoutOutsideOrganization },
    created () {
      document.addEventListener('visibilitychange', this.handleVisibilityChange, false)
      window.addEventListener('online', this.handleVisibilityChange, false)
    },
    beforeDestroy () {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange, false)
      window.removeEventListener('online', this.handleVisibilityChange, false)
    },
    methods: {
      // Checks the connection again on its own, e.g. when the device is back online or the app comes to the foreground
      handleVisibilityChange () {
        if (document.visibilityState === 'visible' && navigator.onLine) {
          this.$refs.aliveCheck.handleSubmit()
        }
      },
      async handleTryAgain (value) {
        if(value) {
          this.$router.replace({ path: this.$route.query.from })
        }
      }
    }
  }
</script>
